import { html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { OutlineCard } from '../../base/outline-card/outline-card';
import '../ghs-heading/ghs-heading';
import '../ghs-card/ghs-card';

import componentStyles from './ghs-cta-collection.css.lit';

/**
 * The CTA collection component.
 */
@customElement('ghs-cta-collection')
export class GhsCtaCollection extends OutlineCard {
  static styles = [componentStyles];

  /**
   * Heading title.
   */
  @property() heading: String;

  render(): TemplateResult {
    return html`
      <div class="cta-collection__card-wrapper">
        <div class="cta-collection__content">
          ${this.heading || this.site == 'GHS'
            ? html`<ghs-heading level="h2" level-style="bold" site=${this.site}>
                ${this.heading}
              </ghs-heading>`
            : nothing}
          <div class="cta-collection__v-separator"></div>
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
}
